
(function ($) {

    'use strict';

    $.FMcore = {

        /**
         *
         *
         * @param
         *
         * @return
         */
        init: function () {

            $(document).ready(function (e) {
                // Botostrap Tootltips
                // $('[data-toggle="tooltip"]').tooltip();

                // Set Background Image Dynamically 
                if ($('[data-bg-img-src]').length) $.FMcore.helpers.bgImage($('[data-bg-img-src]'));

                // Extends jQuery
                $.FMcore.helpers.extendjQuery();

                // Detect Internet Explorer (IE)
                $.FMcore.helpers.detectIE();

            });

            $(window).on('load', function (e) {

            });

        },

        /**
         *
         *
         * @var
         */
        components: {},

        /**
         *
         *
         * @var
         */
        helpers: {

            Math: {

                getRandomValueFromRange: function (startPoint, endPoint, fixed) {

                    var fixedInner = fixed ? fixed : false;

                    Math.random();

                    return fixedInner ? (Math.random() * (endPoint - startPoint) + startPoint) : (Math.floor(Math.random() * (endPoint - startPoint + 1)) + startPoint);

                }

            },

            /**
             * Sets background-image dynamically.
             *
             * @param jQuery collection
             *
             * @return jQuery|undefined
             */
            bgImage: function (collection) {

                if (!collection || !collection.length) return;

                return collection.each(function (i, el) {

                    var $el = $(el),
                        bgImageSrc = $el.data('bg-img-src');

                    if (bgImageSrc) $el.css('background-image', 'url(' + bgImageSrc + ')');

                });

            },

            /**
             * Extends basic jQuery functionality
             *
             * @return undefined
             */
            extendjQuery: function () {

                $.fn.extend({

                    /**
                     * Runs specified function after loading of all images.
                     *
                     * @return Deferred
                     */
                    afterImagesLoaded: function () {

                        var $imgs = this.find('img[src!=""]');

                        if (!$imgs.length) {
                            return $.Deferred().resolve().promise();
                        }

                        var dfds = [];

                        $imgs.each(function () {
                            var dfd = $.Deferred();
                            dfds.push(dfd);
                            var img = new Image();
                            img.onload = function () {
                                dfd.resolve();
                            };
                            img.onerror = function () {
                                dfd.resolve();
                            };
                            img.src = this.src;
                        });

                        return $.when.apply($, dfds);

                    }

                });

            },


            /**
             * Detect Internet Explorer (IE)
             *
             * @return version of IE or false, if browser is not Internet Explorer
             */

            detectIE: function () {

                var ua = window.navigator.userAgent;

                var trident = ua.indexOf('Trident/');
                if (trident > 0) {
                    // IE 11 => return version number
                    var rv = ua.indexOf('rv:');
                    var ieV = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                    document.querySelector('body').className += ' IE';
                }

                var edge = ua.indexOf('Edge/');
                if (edge > 0) {
                    // IE 12 (aka Edge) => return version number
                    var ieV = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
                    document.querySelector('body').className += ' IE';
                }

                // other browser
                return false;

            }

        },

        /**
         *
         *
         * @var
         */
        settings: {
            rtl: false
        }

    };

    $.FMcore.init();

})(jQuery);